import * as React from "react";
import classnames from "classnames";
import { iValidationErrors } from "@/interfaces/validation";
import { List } from "@/components/List";
import { Message } from "@/components/feedback";

interface iProps {
  /**
   * Apply a custom css class to the container.
   */
  className?: string;

  /**
   * The errors to render.
   */
  errors: null | iValidationErrors;
}

/**
 * Renders a list of form validation errors.
 */
// ... (import statements)

/**
 * Renders a list of form validation errors.
 */
export const ValidationErrorsList: React.SFC<iProps> = (props: iProps) => {
  if (!props.errors) {
    return null;
  }

  const keys = Object.keys(props.errors);
  if (!keys.length) {
    return null;
  }

  // Make an array of items.
  const items = [];
  keys.forEach((field, index) => {
    props.errors[field].messages.forEach((message) => {
      items.push({
        key: `${field}-${index}`, // Use a unique key for each Message
        field,
        message,
      });
    });
  });

  const className = classnames("validation-errors-list", props.className);

  return (
    <div className={className}>
      {items.map((item) => (
        <Message key={item.key} theme="danger">
          {item.message}
        </Message>
      ))}
    </div>
  );
};
